export enum BookServiceSellEnum {
  HIRE_EDITORIAL = 1,
  HIRE_DESIGN = 2,
  HIRE_FORMATTING = 3,
}